export class Signer {
    constructor(keychain, modal) {
        this.keychain = keychain;
        this.modal = modal;
    }
    /**
     * Method to get the public key of the signer
     *
     * @returns public key of signer as hex string with 0x prefix
     */
    getPubKey() {
        return Promise.resolve("");
    }
    /**
     * Sign an JSON object for off-chain usage with the starknet private key and return the signature
     * This adds a message prefix so it cant be interchanged with transactions
     *
     * @param typedData - JSON object to be signed
     * @param accountAddress - account
     * @returns the signature of the JSON object
     * @throws {Error} if the JSON object is not a valid JSON
     */
    async signMessage(typedData, account) {
        this.modal.open();
        const res = await this.keychain.signMessage(typedData, account);
        this.modal.close();
        return res;
    }
    async signTransaction(transactions, transactionsDetail, abis) {
        this.modal.open();
        const res = await this.keychain.signTransaction(transactions, transactionsDetail, abis);
        this.modal.close();
        return res;
    }
    async signDeployAccountTransaction(transaction) {
        this.modal.open();
        const res = await this.keychain.signDeployAccountTransaction(transaction);
        this.modal.close();
        return res;
    }
    async signDeclareTransaction(transaction) {
        this.modal.open();
        const res = await this.keychain.signDeclareTransaction(transaction);
        this.modal.close();
        return res;
    }
}
//# sourceMappingURL=signer.js.map